import React from "react";

function TextBold(props) {
  return (
    <p className="fw-bold mb-0">{props.text}</p>
  );
}

export default TextBold;